export const DellSVG = () => (
  <svg
    data-testid="dell-logo-svg"
    width={68}
    height={22}
    viewBox="0 0 68 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.795166 1.71051H8.9005L9.78906 1.74756L10.6402 1.82166L11.4547 2.00657L12.2321 2.19184L12.935 2.4879L13.6012 2.78397L14.2304 3.15415L14.8226 3.56137L15.341 4.00565L15.859 4.48663L16.3033 5.00501L16.7101 5.5601L17.0433 6.15223L17.3764 6.74472L17.6354 7.37391L17.8577 8.0031L29.3673 0.600342L33.5493 3.41316L24.5928 9.18666L26.0361 10.149L35.0667 4.41252L38.9522 7.00302L30.0332 12.8877L31.5506 13.8129L40.6175 8.03944V1.71051H47.2795V14.331H53.2013V20.2523H40.6175V14.1827L29.404 21.3999L17.9678 13.6647L17.7455 14.331L17.5235 14.9601L17.1904 15.5893L16.8573 16.2189L16.45 16.774L16.0058 17.3294L15.5248 17.8474L14.9697 18.2914L14.4146 18.7356L13.7484 19.1058L13.0821 19.4389L12.3418 19.735L11.5644 19.957L10.7503 20.1048L9.89915 20.216L8.9739 20.253H0.795166V1.71051ZM7.16115 7.52105H8.9005L9.6779 7.59516L10.3071 7.81712L10.8622 8.15024L11.3432 8.59452L11.6766 9.11255L11.9356 9.66799L12.0835 10.2972L12.1206 10.9264L12.0835 11.5555L11.9356 12.1851L11.6766 12.7402L11.3065 13.2586L10.8622 13.7025L10.3071 14.036L9.64085 14.2579L8.9005 14.332H7.16115V7.52105ZM54.8669 1.71051H61.566V14.331H67.451V20.2523H54.8672L54.8669 1.71051Z"
      fill="#0382C7"
    />
  </svg>
)
